<style scoped>
  .card-section {
    line-height: 25px;
    font-size: 1em;
    padding: 0 10px;
  }
</style>

<template>
  <app-layout class="profile-view-template" v-if="!info.isLoading">
    <div class="bookmark-section" v-if="section == 'bookmarks'">
      <BookmarkComponent></BookmarkComponent>
    </div>
    <div class="groups-section" v-if="section == 'groups'">
      <Groups style="padding:0 0 60px"></Groups>
      <!-- <ResourceListItemPublicComponent></ResourceListItemPublicComponent> -->
    </div>
    <div class="advocacies-section" v-if="section == 'advocacies' && 'id' in userData">
      <ViewUserProfileAdvocacies :uid="userData.journal_id"></ViewUserProfileAdvocacies>
    </div>
    <div class="organization-section" v-if="section == 'organizations' && 'id' in userData">
      <ViewUserProfileOrganization :uid="userData.journal_id"></ViewUserProfileOrganization>
    </div>
    <div class="organization-section" v-if="section == 'events' && 'id' in userData">
      <EventsPublicComponent :uid="userData.journal_id"></EventsPublicComponent>
    </div>
    <div class="organization-section" v-if="section == 'followers' && 'id' in userData">
      <Row type="flex" justify="center" v-if="'subscribers' in info.userFollowers">
        <i-col v-if="info.userFollowers.subscribers.length > 0" :span="24" v-for="(item, k) in info.userFollowers.subscribers" :key="k">
          <UserListItemComponent :item="item"></UserListItemComponent>
        </i-col>
        <i-col v-if="info.userFollowers.subscribers.length <= 0" :span="24">
          <p align="center" style="padding:20px 0;color:#aaa"><b>0 followers</b></p>
        </i-col>
      </Row>
    </div>
    <div class="organization-section" v-if="section == 'following' && 'id' in userData">
      <Row type="flex" justify="center" v-if="'subscribers' in info.userFollowing">
        <i-col v-if="info.userFollowing.subscribers.length > 0" :span="24" v-for="(item, k) in info.userFollowing.subscribers" :key="k">
          <UserListItemComponent :item="item"></UserListItemComponent>
        </i-col>
        <i-col v-if="info.userFollowing.subscribers.length <= 0" :span="24">
          <p align="center" style="padding:20px 0;color:#aaa"><b>0 Following</b></p>
        </i-col>
      </Row>
    </div>
    <div class="about-section" v-if="section == 'about'">
      <Card shadow :padding="10">
        <div class="card-section">
          <p style="color:#aaa;margin:0"><b>Educational Background</b></p>
          <p style="line-height:20px">{{userData.education || 'No educational background specified'}}</p>
        </div>
      </Card>
      <Card shadow :padding="10">
        <div class="card-section">
          <p style="color:#aaa;margin:0"><b>Accomplishments</b></p>
          <p style="line-height:20px">{{userData.accomplishment || 'No accomplishments specified'}}</p>
        </div>
      </Card>
      <Card shadow :padding="10">
        <div class="card-section">
          <p style="color:#aaa;margin:0"><b>Notes</b></p>
          <p style="line-height:20px">{{userData.notable || 'No notes specified'}}</p>
        </div>
      </Card>
    </div>
  </app-layout>
</template>

<script>
import BookmarkComponent from '@/components/BookmarkComponent'
import ViewUserProfileAdvocacies from '@/views/ViewUserProfileAdvocacies'
import ResourceListItemPublicComponent from "@/components/ResourceListItemPublicComponent";
import ViewUserProfileOrganization from '@/views/ViewUserProfileOrganization';
import UserListItemComponent from '@/components/UserListItemComponent'
import Groups from '@/views/GroupsComponent'
import EventsPublicComponent from '@/views/EventsPublicComponent'

export default {
  components: {
    BookmarkComponent,
    Groups,
    ViewUserProfileAdvocacies,
    ResourceListItemPublicComponent,
    ViewUserProfileOrganization,
    UserListItemComponent,
    EventsPublicComponent
  },
  methods: {
    loadData() {
      this.$store.dispatch('publicProfile/getUserInfo', this.$route.params.uid)
      .then(res=> {
        this.userData = res;
        this.$store.dispatch('user/getUserBookmarks', {id: this.userData.id})

        if( this.section == 'followers')
          this.$store.dispatch('publicProfile/getUserFollowers', {id: this.userData.id})
        if( this.section == 'following')
          this.$store.dispatch('publicProfile/getUserFollowing', {id: this.userData.id})
      });
    }
  },
  created() {
    this.loadData()
  },
  watch: {
    '$route': function(n,o) {
      if (n) {
        this.loadData()
      }
    }
  },
  data() {
    return {
      userData: {},
      permissionData: {
        careplan_id: null,
        user_id: null,
        permission: null,
      },
      setPermissionType: null,
    }
  },
  computed: {
    info: {
      get() {
        return this.$store.state.publicProfile.info
      }
    },
    section: {
      get() {
        if ( this.$route.query.section ) {
          return this.$route.query.section
        } else {
          // this lines is overriding the report concern's query param
          // ------------------------------------------------------------------------------
          // this.$router.replace({query: {
          //   section: 'about'
          // }})
          // return 'about'
          // ------------------------------------------------------------------------------
        }
      },
      set(v) {
        this.$router.replace({query: {
          section: v
        }})
        this.section = v;
      }
    }
  }
}
</script>

<style>

</style>
